import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./MercadoPagoSucesso.module.css";

function MercadoPagoSucesso() {
  const navigate = useNavigate();

  const voltarConfiguracoes = () => {
    navigate("/configuracoes");
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.iconContainer}>
          <div className={styles.iconCircle}>
            <svg
              className={styles.checkIcon}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </div>
        </div>

        <h1 className={styles.title}>Conta conectada com sucesso!</h1>

        <p className={styles.description}>
          Sua conta do Mercado Pago foi vinculada ao seu estabelecimento.
          Agora você pode receber pagamentos diretamente pela plataforma.
        </p>

        <div className={styles.infoBox}>
          <div className={styles.infoIcon}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="16" x2="12" y2="12"></line>
              <line x1="12" y1="8" x2="12.01" y2="8"></line>
            </svg>
          </div>
          <p className={styles.infoText}>
            Os pagamentos serão depositados automaticamente na sua conta do Mercado Pago.
          </p>
        </div>

        <button className={styles.btnVoltar} onClick={voltarConfiguracoes}>
          Voltar para Configurações
        </button>
      </div>
    </div>
  );
}

export default MercadoPagoSucesso;
